<template>
  <notifications group="custom">
    <template #body="props">
      <div
        class="p-3 rounded-2xl top-3 right-3 bg-red-600 text-white my-3 mr-3 text-xs"
      >
        <div v-html="props.item.text" />
      </div>
    </template>
  </notifications>
  <Header />
  <div class="flex flex-col md:flex-row lg:overflow-hidden">
    <Aside />
    <router-view />
  </div>
  <notifications position="bottom right" />
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { exponentialBackoff } from "@/factories/Utils";
import Header from "@/sections/Header";
import Aside from "@/sections/Aside";
import Dashboard from "@/pages/Dashboard";
import Footer from "@/sections/Footer";

export default {
  components: {
    Header,
    Aside,
    Dashboard,
    Footer,
  },
  computed: {
    ...mapGetters(["checkAlreadyConnected"]),
  },

  methods: {
    ...mapActions([
      "initWithoutBeingConnected",
      "init",
      "getBtcData",
    ]),
  },

  async mounted() {
    this.$gtag.pageview("/");
    this.getBtcData();
    exponentialBackoff(
      async () => await this.initWithoutBeingConnected()
    );
    if (this.checkAlreadyConnected) {
      exponentialBackoff(async () => await this.init());
    }
  },
};
</script>
